import React, { useState, useEffect } from "react"
import Layout from "../../components/layout/layout"
import Content from "../../components/content/content"
import Header from "../../components/header/header"
import Breadcrumbs from "../../components/breadcrumbs/breadcrumbs"
import {
  Row,
  Col,
  Table,
  Tooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Button,
  Label,
  Input,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  InputGroup,
  InputGroupAddon,
} from "reactstrap"
import * as Sentry from "@sentry/gatsby"
import { fetch_get, fetch_post } from "../../utils/fetch"
import { checkPassword, getUrlParams } from "../../utils/common"
import { PropagateLoader } from "react-spinners"
import { css } from "glamor"
import { useAuth0 } from "@auth0/auth0-react"
import classnames from "classnames"
import Pagination from "@material-ui/lab/Pagination"
import _ from "lodash"
import {
  Tooltip as MateriaUiTooltip,
  makeStyles,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Popover,
  Typography,
  Checkbox,
} from "@material-ui/core"
import { FaRegEye, FaSearch } from "react-icons/fa"
import { MdClose } from "react-icons/md"
import { BsCheckCircle, BsAlarm, BsXCircle } from "react-icons/bs"
import { BiLoader } from "react-icons/bi"
import { RiAlarmWarningLine } from "react-icons/ri"
import moment from "moment"
import { useUserOrgs } from "../../hooks/use-user"
import { useSearch } from "../../hooks/use-search"
import { navigate } from "gatsby"
import ProjectLinksView from "../project-form/projectLinks/links-display"
import { AiOutlineFilter } from "react-icons/ai"
import { BiSortDown, BiSortUp } from "react-icons/bi"
import { toast } from "react-toastify"
import CIStatus from "./CI/ci-status"
import CIUsageIndex from "../project-form/CIUsage/projectcontrols"

function ProjectButton(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)
  if (!props.URL) {
    return <></>
  }
  let attr = props.Label === "Artifacts" ? { onClick: props.handleClick } : { href: props.URL }
  return (
    <>
      <div style={{ display: "inline-table" }}>
        <Button {...attr} color="primary" className="mr-2 viewPublicProjects">
          <img
            className={`img-fluid d-inline-block`}
            {...css({ height: 25, marginRight: "5px" })}
            src={
              props.projectStatus === "active"
                ? `/${props.Label.toLocaleLowerCase()}.svg`
                : `/${props.Label.toLocaleLowerCase()}-grey.svg`
            }
            alt={props.Label}
            id={`project-${props.Label}`}
          />
          {props.Label}
        </Button>
      </div>
    </>
  )
}

export default function ProjectList(props) {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0()
  const [loading, setLoading] = useState(true)
  const [gotError, setGotError] = useState(false)
  const [tabContentLoading, setTabContentLoading] = useState(false)
  const [tabContentError, setTabContentError] = useState(false)
  const [projectName, setProjectName] = useState("")
  const [projectDescription, setProjectDescription] = useState("")
  const [gitUrl, setGitUrl] = useState("")
  const [wikiUrl, setWikiUrl] = useState("")
  const [wikiRSS, setWikiRSS] = useState("")
  const [artifactoryUrl, setArtifactoryUrl] = useState("")
  const [controllersData, setControllersData] = useState([])
  const [licensesData, setLicensesData] = useState([])
  const [mirrorsData, setMirrorsData] = useState([])
  const [artifactRepos, setArtifactRepos] = useState([])
  const [pageCount, setPageCount] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [status, setStatus] = useState(["pending", "in-progress", "mirrored", "inactive", "failed"])
  const [statusCode, setStatusCode] = useState("all")
  const [selectMirror, setSelectMirror] = useState({})
  const [mirrorModal, setMirrorModal] = useState(false)
  const [tabsName, setTabsName] = useState([])
  const [activeTab, setActiveTab] = useState("0")
  const [projectStatus, setProjectStatus] = useState("")
  const [useUrlParamsToGetInitMirror, setUseUrlParamsToGetInitMirror] = useState(false)
  const [frequencyAnchorEl, setFrequencyAnchorEl] = useState(null)
  const [statusAnchorEl, setStatusAnchorEl] = useState(null)
  const [frequency, setFrequency] = useState(["daily", "once", "weekly"])
  const [dateUpdatedSort, setDateUpdatedSort] = useState("desc")
  const [projParentOrgName, setprojParentOrgName] = useState(null)

  const [projectGetResponse, setProjectGetResponse] = useState({})
  const {
    currentOrg: {
      index,
      name,
      role: { isSuperAdmin, isSystemAdmin, isProjectAdmin },
    },
  } = useUserOrgs()
  var corg = useUserOrgs()
  const [ciEnableEl, setCiEnableEl] = useState(null)
  const [isTabsRegenerated, setIsTabsRegenerated] = useState(false)
  const isUserOrgAndProjectOrgTheSame = () => {
    var qc = ""
    if (corg.currentOrg.name !== null) {
      var qc =
        corg.currentOrg.name.toLowerCase() == "quic, inc."
          ? "clo"
          : corg.currentOrg.name.toLowerCase()
    }
    // var x = props.parentOrganization.toLowerCase() === qc
    var x =
      props.parentOrganization.toLowerCase() === qc ||
      (projParentOrgName !== null && projParentOrgName === qc)
    //console.log(x, props.parentOrganization.toLowerCase(), corg.currentOrg.name.toLowerCase())
    return x
  }

  var locationHash = typeof window !== `undefined` ? window.location.hash : null
  /*const isOperate = (
    user["https://api.codelinaro.org/single-project-admin"]?.find(
      p => p.parentOrganization === name,
    )?.projects || []
  ).find(p => p.slug === props.projectSlug)*/
  const isOperate =
    user?.["https://api.codelinaro.org/single-project-admin"]
      ?.find(p => p.parentOrganization === name)
      ?.projects?.find(p => p.slug === props.projectSlug) ?? null

  const useStyles = makeStyles(theme => ({
    modal: {
      width: 900,
    },
    typography: {
      padding: theme.spacing(2),
    },
    root: {
      marginTop: "15px",
      marginBottom: "15px",
    },
    paper: {
      width: 330,
      height: 300,
      overflow: "auto",
    },
    button: {
      margin: theme.spacing(0.5, 0),
    },
    modalFooterButton: {
      justifyContent: "space-between",
    },

    tabContent: {
      marginTop: "20px",
      // height: "600px",
      maxheight: "600px",
      overflowY: "auto",
      overflowX: "hidden",
    },
    marginTop20: {
      marginTop: "20px",
    },
  }))
  const classes = useStyles()

  const handleCiEnableClose = () => {
    setCiEnableEl(null)
  }

  const handleCiEnableOpen = e => {
    setCiEnableEl(e.currentTarget)
  }

  const callback = v => {
    if (checkPassword(isAuthenticated, user)) return
    setCurrentPage(1)
    setTabContentLoading(true)
    setTabContentError(false)
    const searchValue = v?.target?.value || ""
    getProjectMirrors(
      1,
      pageSize,
      status,
      statusCode,
      dateUpdatedSort,
      frequency,
      !!searchValue,
      searchValue
    ).catch(error => {
      setTabContentLoading(false)
      setTabContentError("An error occurred while getting the list of mirrors.")
      console.log(`Error while getting project mirrors: ${error}`)
      Sentry.captureException(error)
    })
  }

  const { search, setSearch, callback: handleSearchValue } = useSearch(callback)

  function ProjectTable(props) {
    return (
      <>
        {props.data.length > 0 ? (
          <Row>
            <Col>
              <div className="table-border">
                <Table>
                  <tbody>
                    {props.data.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td width="30%">{item.displayName || "-"}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        ) : (
          <p>There are no controllers.</p>
        )}
      </>
    )
  }

  const changeTab = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      if (tab === "4")
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + "#artifacts"
        ) //window.location.hash = "artifacts"
    }
    setTabContentLoading(true)
    setTabContentError(false)
    switch (tab) {
      case "0":
        // window.location.hash = "overview"
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + "#overview"
        )
        setControllersData([])
        getProjectDetail().catch(error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of controllers.")
          console.log(`Error while getting project controllers: ${error}`)
          Sentry.captureException(error)
        })
        setLicensesData([])
        getProjectLicenses().catch(error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of licenses.")
          console.log(`Error while getting project licenses: ${error}`)
          Sentry.captureException(error)
        })
        break
      case "1":
        if (checkPassword(isAuthenticated, user)) return
        // window.location.hash = "controllers"
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + "#controllers"
        )
        setControllersData([])
        getProjectDetail().catch(error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of controllers.")
          console.log(`Error while getting project controllers: ${error}`)
          Sentry.captureException(error)
        })
        break
      case "2":
        if (checkPassword(isAuthenticated, user)) return
        // window.location.hash = "licenses"
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + "#licenses"
        )
        setLicensesData([])
        getProjectLicenses().catch(error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of licenses.")
          console.log(`Error while getting project licenses: ${error}`)
          Sentry.captureException(error)
        })
        break
      case "3":
        if (checkPassword(isAuthenticated, user)) return
        // window.location.hash = "mirrors"
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + "#mirrors"
        )
        setCurrentPage(1)
        setPageSize(10)
        setStatus(["pending", "in-progress", "mirrored", "inactive", "failed"])
        setStatusCode("all")
        setDateUpdatedSort("desc")
        setFrequency(["daily", "once", "weekly"])
        setMirrorsData([])
        setSearch("")
        getProjectMirrors(
          1,
          10,
          ["pending", "in-progress", "mirrored", "inactive", "failed"],
          "all",
          "desc",
          ["daily", "once", "weekly"],
          false
        ).catch(error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of mirrors.")
          console.log(`Error while getting project mirrors: ${error}`)
          Sentry.captureException(error)
        })
        break
      case "5":
        window.history.pushState("", "", window.location.origin + window.location.pathname + "#cu")
        break
      default:
        break
    }
  }

  const navLink = tabsName => {
    return tabsName.map(item => {
      return (
        <NavItem key={item.id}>
          <NavLink
            className={classnames({ active: activeTab === item.id })}
            onClick={() => {
              changeTab(item.id)
            }}
            key={item.id}
            {...css(styles.navLink)}
          >
            {item?.value}
          </NavLink>
        </NavItem>
      )
    })
  }

  function getAdditionalUrlParams() {
    var urlparams = ""
    if (isSuperAdmin || props.path === "/projects/:parentOrganization/:id") {
      urlparams = `?parentOrganization=${props.parentOrganization}`
    } else {
      urlparams = `?index=${index}`
    }
    return urlparams
  }

  const getProjectArtifactReposApi = (page, limit) => {
    var urlparams = getAdditionalUrlParams()
    urlparams = urlparams.replace("?", "&")
    if (props.path === "/projects/:parentOrganization/:id") {
      let url = `projects/public/${props.projectSlug}/artifactory/repos?page=${page}&limit=${limit}${urlparams}`
      return fetch_get(url, false)
    } else {
      let url = `projects/${props.projectSlug}/artifactory/repos?page=${page}&limit=${limit}${urlparams}`
      return getAccessTokenSilently().then(accessToken => fetch_get(url, accessToken))
    }
  }

  const getProjectDetailApi = () => {
    var urlparams = getAdditionalUrlParams()
    if (props.path === "/projects/:parentOrganization/:id") {
      return fetch_get(`projects/public/${props.projectSlug}${urlparams}`, false)
    } else {
      return getAccessTokenSilently().then(accessToken =>
        fetch_get(`projects/${props.projectSlug}${urlparams}`, accessToken)
      )
    }
  }

  const getProjectLicensesApi = () => {
    var urlparams = getAdditionalUrlParams()

    if (props.path === "/projects/:parentOrganization/:id") {
      return fetch_get(`projects/public/${props.projectSlug}/licenses${urlparams}`, false)
    } else {
      return getAccessTokenSilently().then(accessToken =>
        fetch_get(`projects/${props.projectSlug}/licenses${urlparams}`, accessToken)
      )
    }
  }

  const getProjectMirrorsApi = (
    page,
    limit,
    status,
    code,
    order,
    frequency,
    isUseSearch,
    searchValue
  ) => {
    var urlparams = getAdditionalUrlParams()
    urlparams = urlparams.replace("?", "&")
    let queryUrl = `?page=${page}&limit=${limit}&order=${order}`
    if (props.path === "/projects/:parentOrganization/:id") {
      let url = `projects/public/${props.projectSlug}/git/mirrors?page=${page}&limit=${limit}&order=${order}${urlparams}`
      if (status.length > 0) {
        url = url + `&status=${status.join(",")}`
        queryUrl = queryUrl + `&status=${status.join(",")}`
      }
      if (code !== "all") {
        url = url + `&statusCode=${code}`
        queryUrl = queryUrl + `&statusCode=${code}`
      }
      if (frequency.length > 0) {
        url = url + `&frequency=${frequency.join(",")}`
        queryUrl = queryUrl + `&frequency=${frequency.join(",")}`
      }
      if (isUseSearch) {
        if (searchValue && searchValue !== "") {
          url += `&query=${searchValue}`
          queryUrl += `&search=${searchValue}`
        } else {
          if (search !== "") {
            url += `&query=${search}`
            queryUrl += `&search=${search}`
          }
        }
      }
      if (activeTab === "3")
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + queryUrl + window.location.hash
        )
      return fetch_get(url, false)
    } else {
      let url = `projects/${props.projectSlug}/git/mirrors?page=${page}&limit=${limit}&order=${order}${urlparams}`
      if (status.length > 0) {
        url = url + `&status=${status.join(",")}`
        queryUrl = queryUrl + `&status=${status.join(",")}`
      }
      if (code !== "all") {
        url = url + `&statusCode=${code}`
        queryUrl = queryUrl + `&statusCode=${code}`
      }
      if (frequency.length > 0) {
        url = url + `&frequency=${frequency.join(",")}`
        queryUrl = queryUrl + `&frequency=${frequency.join(",")}`
      }
      if (isUseSearch) {
        if (searchValue && searchValue !== "") {
          url += `&query=${searchValue}`
          queryUrl += `&search=${searchValue}`
        } else {
          if (search !== "") {
            url += `&query=${search}`
            queryUrl += `&search=${search}`
          }
        }
      }
      if (activeTab === "3")
        window.history.pushState(
          "",
          "",
          window.location.origin + window.location.pathname + queryUrl + window.location.hash
        )
      return getAccessTokenSilently().then(accessToken => fetch_get(url, accessToken))
    }
  }

  const getProjectMirrorApi = mid => {
    var urlparams = getAdditionalUrlParams()
    if (props.path === "/projects/:parentOrganization/:id") {
      let url = `projects/public/${props.projectSlug}/git/mirrors/${mid}${urlparams}`
      return fetch_get(url, false)
    } else {
      let url = `projects/${props.projectSlug}/git/mirrors/${mid}${urlparams}`
      return getAccessTokenSilently().then(accessToken => fetch_get(url, accessToken))
    }
  }

  const getProjectDetail = () => {
    return getProjectDetailApi().then(response => {
      // console.log(response)
      setProjectGetResponse(response)
      setTabContentLoading(false)
      setTabContentError(false)
      setProjectName(response.name)
      setprojParentOrgName(response.parentOrganization.toLowerCase())
      setProjectDescription(response.description)
      setProjectStatus(response.status)
      setGitUrl(response.gitlabURL)
      setWikiUrl(response.wikiURL)
      if (response.wikiURL && response.status === "active" && response.visibility === "public") {
        let rssFeed = process.env.CL_API_ENDPOINT + "/projects/" + response.projectId + "/wiki/rss"
        setWikiRSS(rssFeed)
      }
      setArtifactoryUrl(response.artifactoryURL)
      if (response.roles.hasOwnProperty("controllers")) {
        setControllersData(response.roles.controllers)
      }
    })
  }

  const save_ci_status = status => {
    var stext = status ? "enable" : "disable"

    var urlparams = getAdditionalUrlParams()
    setCiEnableEl(null)
    getAccessTokenSilently()
      .then(accessToken =>
        fetch_post(
          `projects/${props.projectSlug}/git/ci${urlparams}`,
          { enable_ci: status },
          accessToken
        )
      )
      .then(response => {
        var temp = JSON.parse(JSON.stringify(projectGetResponse))
        temp.ci_status.enabled = !projectGetResponse.ci_status.enabled
        setProjectGetResponse(temp)
        toast(`CI Status Updated Successfully`, {
          type: "success",
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      })
      .catch(error => {
        toast(`${error}`, {
          type: "error",
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      })
  }

  const getProjectLicenses = () => {
    return getProjectLicensesApi().then(response => {
      setTabContentLoading(false)
      setTabContentError(false)
      setLicensesData(response)
    })
  }

  const getProjectMirrors = (
    page,
    limit,
    status,
    code,
    order,
    frequency,
    isUseSearch,
    searchValue
  ) => {
    return getProjectMirrorsApi(
      page,
      limit,
      status,
      code,
      order,
      frequency,
      isUseSearch,
      searchValue
    ).then(response => {
      setTabContentLoading(false)
      setTabContentError(false)
      setMirrorsData(response["data"] || [])
      const totalRecords = response["pagination"]["totalRecords"] || 0
      const pageSize = response["pagination"]["pageSize"] || 10
      setPageCount(Math.ceil(totalRecords / pageSize))
    })
  }
  const getProjectArtifactRepos = (page, limit) => {
    return getProjectArtifactReposApi(page, limit).then(response => {
      setTabContentLoading(false)
      setTabContentError(false)
      setArtifactRepos(response["data"] || [])
      const totalRecords = response["pagination"]["totalRecords"] || 0
      const pageSize = response["pagination"]["pageSize"] || 10
      setPageCount(Math.ceil(totalRecords / pageSize))
    })
  }

  useEffect(() => {
    if (loading) return
    if (locationHash.replace("#", "") === "artifacts" && artifactoryUrl) {
      setActiveTab("4")
      if (checkPassword(isAuthenticated, user)) return
      setCurrentPage(1)
      setPageSize(10)
      setTabContentLoading(true)
      setTabContentError(false)
      setArtifactRepos([])
      getProjectArtifactRepos(1, 10).catch(error => {
        setTabContentLoading(false)
        setTabContentError("An error occurred while getting the list of artifact repos.")
        console.log(`Error while getting project artifact repos: ${error}`)
        Sentry.captureException(error)
      })
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationHash, loading])

  useEffect(() => {
    if (isSuperAdmin === undefined || isSuperAdmin === null) return
    if (checkPassword(isAuthenticated, user)) return
    setLoading(true)
    const project_details = getProjectDetail().catch(error => {
      console.log(error)
      setGotError(
        "An error has occurred while trying to retrieve the information for this project. If this continues, please raise a support ticket."
      )
    })

    const project_licenses = getProjectLicenses().catch(error => {
      console.log(error)
      setGotError("An error occurred while getting the list of licenses.")
    })
    setSearch("")
    const project_mirrors = getProjectMirrors(
      1,
      10,
      status,
      statusCode,
      dateUpdatedSort,
      frequency,
      false
    ).catch(error => {
      console.log(error)
      setGotError("An error occurred while getting the list of mirrors.")
    })

    Promise.all([project_details, project_licenses, project_mirrors]).then(() => {
      setLoading(false)
    })

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.projectSlug, props.parentOrganization, isSuperAdmin])

  const check_if_user_is_single_project_admin = () => {
    var key = "https://api.codelinaro.org/single-project-admin"
    if (user?.[key] !== undefined && user[key] !== null) {
      for (let item of user[key]) {
        if ((item.projects || []).find(p => p.slug === props.projectSlug)) return true
      }
    }
    return false
  }

  useEffect(() => {
    if (!loading) {
      setIsTabsRegenerated(false)
      let newTabsName = [{ id: "0", value: "Overview" }]

      if (controllersData.length > 0) {
        // newTabsName.push({ id: "1", value: "Controllers" })
      }
      if (licensesData.length > 0) {
        // newTabsName.push({ id: "2", value: "Licenses" })
      }
      if (mirrorsData.length > 0) {
        newTabsName.push({ id: "3", value: "Mirrors" })
      }
      if (artifactoryUrl) {
        newTabsName.push({ id: "4", value: "Artifacts" })
      }
      const isOperate = (
        user?.["https://api.codelinaro.org/single-project-admin"]?.find(
          p => p.parentOrganization === name
        )?.projects || []
      ).find(p => p.slug === props.projectSlug)
      // console.log(
      //   user,
      //   isSuperAdmin,
      //   isProjectAdmin,
      //   isSystemAdmin,
      //   name,
      //   projectGetResponse.parentOrganization,
      //   check_if_user_is_single_project_admin()
      // )
      if (
        (isSuperAdmin ||
          ((isProjectAdmin || isSystemAdmin) && name === projectGetResponse.parentOrganization) ||
          check_if_user_is_single_project_admin()) &&
        gitUrl &&
        gitUrl != ""
      ) {
        newTabsName.push({ id: "5", value: "CI Usage" })
      }
      if (newTabsName.length > 0) {
        if (locationHash.replace("#", "") === "artifacts" && artifactoryUrl) {
          setActiveTab("4")
        } else if (locationHash.replace("#", "") === "cu") {
          if (
            isSuperAdmin ||
            ((isProjectAdmin || isSystemAdmin) && name === projectGetResponse.parentOrganization)
          ) {
            setActiveTab("5")
          } else {
            window.location.hash = ""
          }
        } else {
          const findTab = newTabsName.find(
            tab => tab.value.toLocaleLowerCase() === window.location.hash.replace("#", "")
          )
          if (findTab) {
            setActiveTab(findTab.id)
            if (findTab.id === "3") {
              let queryParams = new URLSearchParams(getUrlParams(window.location.search))
              let flag = false
              if (queryParams.has("page") && queryParams.get("page") !== "1") {
                setCurrentPage(parseInt(queryParams.get("page")))
                flag = true
              }
              if (queryParams.has("limit") && queryParams.get("limit") !== "10") {
                setPageSize(parseInt(queryParams.get("limit")))
                flag = true
              }
              if (queryParams.has("status")) {
                setStatus(queryParams.get("status").split(","))
                flag = true
              }
              if (queryParams.has("frequency")) {
                setFrequency(queryParams.get("frequency").split(","))
                flag = true
              }
              if (queryParams.has("order")) {
                setDateUpdatedSort(queryParams.get("order"))
                flag = true
              }
              if (queryParams.has("statusCode")) {
                setStatusCode(queryParams.get("statusCode"))
                flag = true
              }
              if (queryParams.has("search")) {
                setSearch(queryParams.get("search"))
                flag = true
              }
              setUseUrlParamsToGetInitMirror(flag)
              if (queryParams.has("mid")) {
                getProjectMirrorApi(queryParams.get("mid"))
                  .then(response => {
                    showMirrorModal(response)
                  })
                  .catch(() => {
                    let queryParams = new URLSearchParams(getUrlParams(window.location.search))
                    queryParams.delete("mid")
                    window.history.pushState(
                      "",
                      "",
                      window.location.origin +
                        window.location.pathname +
                        `?${queryParams.toString()}` +
                        window.location.hash
                    )
                  })
              }
            }
          } else {
            window.location.hash = ""
            setActiveTab(newTabsName[0].id)
          }
        }
      }
      setTabsName(newTabsName)
      setIsTabsRegenerated(true)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])
  useEffect(() => {
    // console.log(projectGetResponse)

    if (gitUrl === undefined || gitUrl === null || gitUrl === "") return
    if (!isTabsRegenerated) return
    if (projectGetResponse === undefined) return
    if (projectGetResponse.ci_status === undefined) return
    if (
      projectGetResponse.ci_status.enabled === undefined ||
      projectGetResponse.ci_status.enabled === null
    )
      return
    var tabid = "5"
    if (
      isSuperAdmin ||
      ((isProjectAdmin || isSystemAdmin) && name === projectGetResponse.parentOrganization) ||
      check_if_user_is_single_project_admin()
    ) {
      if (projectGetResponse.ci_status.enabled && projectGetResponse.ci_status.allowed_by_org) {
        var t = JSON.parse(JSON.stringify(tabsName))
        t = t.filter(function (obj) {
          return obj.id !== tabid
        })
        t.push({ id: tabid, value: "CI Usage" })
        setTabsName(t)
      } else {
        var t = JSON.parse(JSON.stringify(tabsName))
        var myArray = t.filter(function (obj) {
          return obj.id !== tabid
        })
        setTabsName(myArray)
        if (activeTab === tabid) setActiveTab("0")
      }
    }
    // setIsTabsRegenerated(false)
  }, [projectGetResponse, isTabsRegenerated, gitUrl])

  // useEffect(() => {
  //   console.log(tabsName)
  // }, [tabsName])

  useEffect(() => {
    if (!useUrlParamsToGetInitMirror) return
    setTabContentLoading(true)
    getProjectMirrors(
      currentPage,
      pageSize,
      status,
      statusCode,
      dateUpdatedSort,
      frequency,
      true,
      search
    ).catch(error => {
      setTabContentLoading(false)
      setTabContentError("An error occurred while getting the list of mirrors.")
      console.log(`Error while getting project mirrors: ${error}`)
      Sentry.captureException(error)
    })
  }, [useUrlParamsToGetInitMirror])

  function onPageChange(event, page) {
    setCurrentPage(page)
    setTabContentLoading(true)
    setTabContentError(false)
    if (checkPassword(isAuthenticated, user)) return
    if (activeTab === "4") {
      getProjectArtifactRepos(page, pageSize).catch(error => {
        setTabContentLoading(false)
        setTabContentError("An error occurred while getting the list of artifact repos.")
        console.log(`Error while getting project artifact repos: ${error}`)
        Sentry.captureException(error)
      })
    } else {
      getProjectMirrors(page, pageSize, status, statusCode, dateUpdatedSort, frequency, true).catch(
        error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of mirrors.")
          console.log(`Error while getting project mirrors: ${error}`)
          Sentry.captureException(error)
        }
      )
    }
  }

  function onPageSizeChange(event) {
    if (checkPassword(isAuthenticated, user)) return
    const size = parseInt(event.target.value, 10)
    setPageSize(size)
    setCurrentPage(1)
    setTabContentLoading(true)
    setTabContentError(false)
    if (activeTab === "4") {
      getProjectArtifactRepos(1, size).catch(error => {
        setTabContentLoading(false)
        setTabContentError("An error occurred while getting the list of artifact repos.")
        console.log(`Error while getting project artifact repos: ${error}`)
        Sentry.captureException(error)
      })
    } else {
      getProjectMirrors(1, size, status, statusCode, dateUpdatedSort, frequency, true).catch(
        error => {
          setTabContentLoading(false)
          setTabContentError("An error occurred while getting the list of mirrors.")
          console.log(`Error while getting project mirrors: ${error}`)
          Sentry.captureException(error)
        }
      )
    }
  }

  const handleStatus = (type, checked = "") => {
    if (checkPassword(isAuthenticated, user)) return
    let types = []
    if (checked === "") {
      types = type === "" ? [] : type.split(",")
    } else {
      if (checked) {
        types = [type, ...status]
      } else {
        types = status.filter(f => f !== type)
      }
    }
    setStatus(types)
    setTabContentLoading(true)
    setTabContentError(false)
    setCurrentPage(1)
    getProjectMirrors(1, pageSize, types, statusCode, dateUpdatedSort, frequency, true).catch(
      error => {
        setTabContentLoading(false)
        setTabContentError("An error occurred while getting the list of mirrors.")
        console.log(`Error while getting project mirrors: ${error}`)
        Sentry.captureException(error)
      }
    )
  }

  const handleStatusCode = value => {
    if (checkPassword(isAuthenticated, user)) return
    setTabContentLoading(true)
    setTabContentError(false)
    setStatusCode(value)
    setCurrentPage(1)
    getProjectMirrors(1, pageSize, status, value, dateUpdatedSort, frequency, true).catch(error => {
      setTabContentLoading(false)
      setTabContentError("An error occurred while getting the list of mirrors.")
      console.log(`Error while getting project mirrors: ${error}`)
      Sentry.captureException(error)
    })
  }

  const handleSort = type => {
    if (type === dateUpdatedSort) return
    if (checkPassword(isAuthenticated, user)) return
    setDateUpdatedSort(type)
    setTabContentLoading(true)
    setTabContentError(false)
    setCurrentPage(1)
    getProjectMirrors(1, pageSize, status, statusCode, type, frequency, true).catch(error => {
      setTabContentLoading(false)
      setTabContentError("An error occurred while getting the list of mirrors.")
      console.log(`Error while getting project mirrors: ${error}`)
      Sentry.captureException(error)
    })
  }

  const handleFrequency = (type, checked = "") => {
    if (checkPassword(isAuthenticated, user)) return
    let types = []
    if (checked === "") {
      types = type === "" ? [] : type.split(",")
    } else {
      if (checked) {
        types = [type, ...frequency]
      } else {
        types = frequency.filter(f => f !== type)
      }
    }
    setFrequency(types)
    setTabContentLoading(true)
    setTabContentError(false)
    setCurrentPage(1)
    getProjectMirrors(1, pageSize, status, statusCode, dateUpdatedSort, types, true).catch(
      error => {
        setTabContentLoading(false)
        setTabContentError("An error occurred while getting the list of mirrors.")
        console.log(`Error while getting project mirrors: ${error}`)
        Sentry.captureException(error)
      }
    )
  }

  const restartList = (isUseSearch = false) => {
    if (checkPassword(isAuthenticated, user)) return
    setTabContentLoading(true)
    setTabContentError(false)
    setCurrentPage(1)
    getProjectMirrors(
      1,
      pageSize,
      status,
      statusCode,
      dateUpdatedSort,
      frequency,
      isUseSearch
    ).catch(error => {
      setTabContentLoading(false)
      setTabContentError("An error occurred while getting the list of mirrors.")
      console.log(`Error while getting project mirrors: ${error}`)
      Sentry.captureException(error)
    })
  }

  function UseToolTip(props) {
    const { item, show } = props
    return (
      <>
        <span id={`mirror-${show}-${item.mirrorID}`}>
          {item[show].startsWith("https://") || item[show].startsWith("http://") ? (
            <>
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
              <a
                className="linkJump handlePointer"
                {...css(styles.link)}
                onClick={() => {
                  window.open(`${item[show]}`, "_blank", "noreferrer")
                }}
              >
                {item[show]}
              </a>
            </>
          ) : (
            item[show]
          )}
        </span>
      </>
    )
  }

  const ActionItem = data => {
    return (
      <>
        <MateriaUiTooltip title="View Mirror Details">
          <Button
            outline
            color="dark"
            className="ml-1 border-0 p-0"
            id={`MirrorView-${data.mirrorID}`}
            onClick={() => showMirrorModal(data)}
          >
            <FaRegEye />
          </Button>
        </MateriaUiTooltip>
      </>
    )
  }

  const StatusItem = data => {
    const statusMap = {
      mirrored: <BsCheckCircle color="green" size={24} title="Mirrored" />,
      pending: <BsAlarm size={24} title="Pending" />,
      "in-progress": <BiLoader size={24} title="In-progress" />,
      // active: <BsCheckCircle color="green" size={24} title="Active" />,
      inactive: <RiAlarmWarningLine color="grey" size={24} title="Inactive" />,
      failed: <BsXCircle color="red" size={24} title="Failed" />,
    }
    return statusMap[data]
  }

  const showMirrorModal = data => {
    let queryParams = getUrlParams(window.location.search)
    queryParams["mid"] = data.mirrorID
    window.history.pushState(
      "",
      "",
      window.location.origin +
        window.location.pathname +
        `?${new URLSearchParams(queryParams).toString()}` +
        window.location.hash
    )
    setSelectMirror(data)
    setMirrorModal(!mirrorModal)
  }

  const mirrorModalRender = () => {
    return (
      <Form method="POST" {...css(styles.modal)}>
        <FormGroup>
          <Label for="mirrorID">Mirror ID</Label>
          <Input type="text" name="mirrorID" id="mirrorID" value={selectMirror.mirrorID} />
        </FormGroup>
        <FormGroup>
          <Label for="repoURLFrom">Repo URL From</Label>
          <Input type="text" name="repoURLFrom" id="repoURLFrom" value={selectMirror.repoURLFrom} />
        </FormGroup>
        <FormGroup>
          <Label for="repoURLTo">Repo URL To</Label>
          <Input type="text" name="repoURLTo" id="repoURLTo" value={selectMirror.repoURLTo} />
        </FormGroup>
        <FormGroup>
          <Label for="refSpaceFrom">Repo Space From</Label>
          <Input
            type="text"
            name="refSpaceFrom"
            id="refSpaceFrom"
            value={selectMirror.refSpaceFrom}
          />
        </FormGroup>
        <FormGroup>
          <Label for="refSpaceTo">Repo Space To</Label>
          <Input type="text" name="refSpaceTo" id="refSpaceTo" value={selectMirror.refSpaceTo} />
        </FormGroup>
        <FormGroup>
          <Label for="frequency">Frequency</Label>
          <Input
            type="text"
            name="frequency"
            id="frequency"
            value={_.upperFirst(selectMirror.frequency)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="excludeTags">Exclude Tags</Label>
          <Input
            type="text"
            name="excludeTags"
            id="excludeTags"
            value={_.upperFirst(selectMirror.excludeTags)}
          />
        </FormGroup>
        <FormGroup>
          <Label for="status">Status</Label>
          <Input type="text" name="status" id="status" value={_.upperFirst(selectMirror.status)} />
        </FormGroup>
        <FormGroup>
          <Label>Status Note</Label>
          <Input
            type="text"
            name="created"
            id="created"
            value={_.upperFirst(selectMirror.statusNote)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Created Date</Label>
          <Input
            type="text"
            name="created"
            id="created"
            value={moment(selectMirror.created).format("YYYY-MM-DD HH:mm:ss")}
          />
        </FormGroup>
        <FormGroup>
          <Label>Last Updated Date</Label>
          <Input
            type="text"
            name="lastUpdated"
            id="lastUpdated"
            value={moment(selectMirror.lastUpdated).format("YYYY-MM-DD HH:mm:ss")}
          />
        </FormGroup>
        <FormGroup>
          <Label>Run Time</Label>
          <Input
            type="text"
            name="runTime"
            id="runTime"
            value={selectMirror.runTime ? `${selectMirror.runTime}S` : ""}
          />
        </FormGroup>
      </Form>
    )
  }

  const getTabContent = type => {
    return tabContentLoading && type !== "mirror" ? (
      <Row>
        <Col
          className="d-flex justify-content-center align-items-center"
          xs={{ size: 12 }}
          sm={{ size: 4, offset: 4 }}
        >
          <PropagateLoader className="align-self-center" size={20} color={"#9c3"} loading={true} />
        </Col>
      </Row>
    ) : !tabContentLoading && tabContentError ? (
      <Row>
        <Col xs={{ size: 12 }}>
          <p {...css(styles.noData)}>{tabContentError}</p>
        </Col>
      </Row>
    ) : type === "controller" ? (
      controllersTableRender()
    ) : type === "license" ? (
      licensesListRender()
    ) : type === "artifacts" ? (
      artifactsTableRender()
    ) : (
      mirrorsTableRender()
    )
  }

  const controllersTableRender = () => {
    return <ProjectTable data={controllersData} name="Controllers" />
  }

  const licensesListRender = () => {
    return licensesData.length > 0 ? (
      <Row>
        <Col>
          <ul>
            {licensesData.map((item, index) => (
              <li key={item.name || index}>
                {" "}
                {/* Ensure the key is unique */}
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
                <a
                  className="linkJump handlePointer"
                  {...css(styles.liceneseName)}
                  onClick={() => {
                    window.open(`${item.link}`, "_blank", "noreferrer")
                  }}
                >{`${item.fullname} (${item.name})`}</a>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    ) : (
      <p>There are no licenses.</p>
    )
  }

  const mirrorsTableRender = () => {
    return (
      <>
        {tabContentLoading && (
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={{ size: 12 }}
            {...css(styles.loader)}
          >
            <PropagateLoader
              className="align-self-center"
              size={20}
              color={"#9c3"}
              loading={true}
            />
          </Col>
        )}
        <div style={{ opacity: tabContentLoading ? ".5" : "1" }}>
          <Row className="justify-content-center mb-2">
            <Col xs={{ size: 6 }} className="d-flex justify-content-center align-items-center">
              <InputGroup>
                <Input
                  value={search}
                  placeholder="Search for Mirror ID or URL From or URL To..."
                  onChange={event => handleSearchValue(event)}
                  onKeyPress={event => {
                    if (event.key === "Enter") {
                      event.preventDefault()
                      document.getElementById("searchButton").click()
                    }
                  }}
                />
                {search !== "" && (
                  <InputGroupAddon
                    className="clear_search"
                    addonType="append"
                    style={{ zIndex: 0 }}
                  >
                    <Button
                      onClick={() => {
                        setSearch("")
                        restartList()
                      }}
                    >
                      <MdClose />
                    </Button>
                  </InputGroupAddon>
                )}
                <InputGroupAddon addonType="append">
                  <Button id="searchButton" onClick={() => restartList(true)}>
                    <FaSearch />
                  </Button>
                </InputGroupAddon>
              </InputGroup>
            </Col>
            <div className="d-flex justify-content-center align-items-center mb-2">
              <div style={{ marginLeft: 50, width: 100 }}>
                <FormControl className="mb-2" style={{ width: "100%" }}>
                  <InputLabel>Status Code</InputLabel>
                  <Select
                    labelId="statusCode"
                    id="status-code"
                    value={statusCode}
                    onChange={e => {
                      handleStatusCode(e.target.value)
                    }}
                  >
                    <MenuItem value={"all"}>All</MenuItem>
                    <MenuItem value={302}>302</MenuItem>
                    <MenuItem value={403}>403</MenuItem>
                    <MenuItem value={404}>404</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </Row>
          <div id="mirrorsWrapper">
            <Row>
              <Col className="d-flex justify-content-center align-items-center mb-2">
                <Pagination
                  count={pageCount}
                  page={currentPage}
                  onChange={onPageChange}
                  variant="outlined"
                  shape="rounded"
                />
                <div className="ml-2">
                  <Select
                    labelId="pageSize"
                    id="page-size"
                    value={pageSize}
                    onChange={onPageSizeChange}
                    className="pageSizeSelect"
                  >
                    <MenuItem value={10}>10 / page</MenuItem>
                    <MenuItem value={50}>50 / page</MenuItem>
                    <MenuItem value={100}>100 / page</MenuItem>
                  </Select>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="table-border" style={{ overflow: "auto" }}>
                  <Table>
                    <thead>
                      <tr>
                        <th>Detail</th>
                        <th>Repo URL From</th>
                        <th>Repo URL To</th>
                        <th>
                          Frequency&nbsp;&nbsp;
                          <AiOutlineFilter
                            color={frequency.length > 0 ? "#9c3" : ""}
                            className="filter-table"
                            onClick={e => {
                              setFrequencyAnchorEl(e.currentTarget)
                            }}
                          />
                        </th>
                        <th>
                          Status&nbsp;&nbsp;
                          <AiOutlineFilter
                            color={status.length > 0 ? "#9c3" : ""}
                            className="filter-table"
                            onClick={e => {
                              setStatusAnchorEl(e.currentTarget)
                            }}
                          />
                        </th>
                        <th>
                          Date Updated&nbsp;&nbsp;
                          <BiSortUp
                            color={dateUpdatedSort === "asc" ? "#9c3" : ""}
                            className="filter-table"
                            onClick={() => handleSort("asc")}
                          />
                          <BiSortDown
                            color={dateUpdatedSort === "desc" ? "#9c3" : ""}
                            className="filter-table"
                            onClick={() => handleSort("desc")}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {mirrorsData.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td width="6%">{ActionItem(item)}</td>
                            <td width="30%" className="word-break-all">
                              <UseToolTip item={item} show="repoURLFrom" />
                            </td>
                            <td width="30%" className="word-break-all">
                              <UseToolTip item={item} show="repoURLTo" />
                            </td>
                            <td width="10%">{_.upperFirst(item.frequency)}</td>
                            <td width="10%">{StatusItem(item.status)}</td>
                            <td width="14%">
                              {item.lastUpdated
                                ? moment(item.lastUpdated).format("YYYY-MM-DD HH:mm:ss")
                                : "-"}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-center align-items-center mb-2">
                <Pagination
                  count={pageCount}
                  page={currentPage}
                  onChange={onPageChange}
                  variant="outlined"
                  shape="rounded"
                />
                <div className="ml-2">
                  <Select
                    labelId="pageSize"
                    id="page-size"
                    value={pageSize}
                    onChange={onPageSizeChange}
                    className="pageSizeSelect"
                  >
                    <MenuItem value={10}>10 / page</MenuItem>
                    <MenuItem value={50}>50 / page</MenuItem>
                    <MenuItem value={100}>100 / page</MenuItem>
                  </Select>
                </div>
              </Col>
            </Row>
            <Popover
              open={!!frequencyAnchorEl}
              anchorEl={frequencyAnchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => {
                setFrequencyAnchorEl(null)
              }}
            >
              <div>
                <Typography>
                  <div style={{ padding: 8 }}>
                    <div>
                      <Checkbox
                        checked={frequency.length === 3}
                        indeterminate={frequency.length !== 3 && frequency.length !== 0}
                        onChange={e => {
                          if (e.target.checked) {
                            handleFrequency("once,daily,weekly")
                          } else {
                            handleFrequency("")
                          }
                        }}
                      />{" "}
                      All
                    </div>
                    <div>
                      <Checkbox
                        checked={frequency.includes("once")}
                        onChange={e => handleFrequency("once", e.target.checked)}
                      />{" "}
                      Once
                    </div>
                    <div>
                      <Checkbox
                        checked={frequency.includes("daily")}
                        onChange={e => handleFrequency("daily", e.target.checked)}
                      />{" "}
                      Daily
                    </div>
                    <div>
                      <Checkbox
                        checked={frequency.includes("weekly")}
                        onChange={e => handleFrequency("weekly", e.target.checked)}
                      />{" "}
                      Weekly
                    </div>
                  </div>
                </Typography>
              </div>
            </Popover>
            <Popover
              open={!!statusAnchorEl}
              anchorEl={statusAnchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => {
                setStatusAnchorEl(null)
              }}
            >
              <div>
                <Typography>
                  <div style={{ padding: 8 }}>
                    <div>
                      <Checkbox
                        checked={status.length === 5}
                        indeterminate={status.length !== 5 && status.length !== 0}
                        onChange={e => {
                          if (e.target.checked) {
                            handleStatus("pending,in-progress,mirrored,inactive,failed")
                          } else {
                            handleStatus("")
                          }
                        }}
                      />{" "}
                      All
                    </div>
                    <div>
                      <Checkbox
                        checked={status.includes("pending")}
                        onChange={e => handleStatus("pending", e.target.checked)}
                      />{" "}
                      Pending
                    </div>
                    <div>
                      <Checkbox
                        checked={status.includes("in-progress")}
                        onChange={e => handleStatus("in-progress", e.target.checked)}
                      />{" "}
                      In-Progress
                    </div>
                    <div>
                      <Checkbox
                        checked={status.includes("mirrored")}
                        onChange={e => handleStatus("mirrored", e.target.checked)}
                      />{" "}
                      Mirrored
                    </div>
                    {/* <div>
                      <Checkbox
                        checked={status.includes("active")}
                        onChange={e => handleStatus("active", e.target.checked)}
                      />{" "}
                      Active
                    </div> */}
                    <div>
                      <Checkbox
                        checked={status.includes("inactive")}
                        onChange={e => handleStatus("inactive", e.target.checked)}
                      />{" "}
                      Inactive
                    </div>
                    <div>
                      <Checkbox
                        checked={status.includes("failed")}
                        onChange={e => handleStatus("failed", e.target.checked)}
                      />{" "}
                      Failed
                    </div>
                  </div>
                </Typography>
              </div>
            </Popover>
            <Modal
              isOpen={mirrorModal}
              toggle={() => setMirrorModal(!mirrorModal)}
              backdrop="static"
              zIndex={1500}
              size="xl"
              centered={true}
              className={classes.modal}
            >
              <ModalHeader
                toggle={() => {
                  let queryParams = new URLSearchParams(getUrlParams(window.location.search))
                  queryParams.delete("mid")
                  window.history.pushState(
                    "",
                    "",
                    window.location.origin +
                      window.location.pathname +
                      `?${queryParams.toString()}` +
                      window.location.hash
                  )
                  setMirrorModal(!mirrorModal)
                }}
              >
                Mirror Detail
              </ModalHeader>
              <ModalBody>{mirrorModalRender()}</ModalBody>
            </Modal>
          </div>
          {/* ) : (
            <p>There are no mirrors.</p>
          )} */}
        </div>
      </>
    )
  }

  const artifactsTableRender = () => {
    const classMap = {
      active: "activeBg",
      inactive: "inactiveBg",
      archived: "archivedBg",
    }
    return (
      <>
        {tabContentLoading && (
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={{ size: 12 }}
            {...css(styles.loader)}
          >
            <PropagateLoader
              className="align-self-center"
              size={20}
              color={"#9c3"}
              loading={true}
            />
          </Col>
        )}
        <div style={{ opacity: tabContentLoading ? ".5" : "1" }}>
          {artifactRepos.length > 0 ? (
            <div id="mirrorsWrapper">
              <Row>
                <Col className="d-flex justify-content-center align-items-center mb-2">
                  <Pagination
                    count={pageCount}
                    page={currentPage}
                    onChange={onPageChange}
                    variant="outlined"
                    shape="rounded"
                  />
                  <div className="ml-2">
                    <Select
                      labelId="pageSize"
                      id="page-size"
                      value={pageSize}
                      onChange={onPageSizeChange}
                      className="pageSizeSelect"
                    >
                      <MenuItem value={10}>10 / page</MenuItem>
                      <MenuItem value={50}>50 / page</MenuItem>
                      <MenuItem value={100}>100 / page</MenuItem>
                    </Select>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div {...css(styles.publicProjectContainer)}>
                    <div>
                      <div>
                        {artifactRepos.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className={`p-4 my-3 ${classMap[projectStatus]}`}
                              style={
                                projectStatus === "active"
                                  ? { backgroundColor: "#ebebeb" }
                                  : { backgroundColor: "#fff", border: "1px solid #ebebeb" }
                              }
                            >
                              <h5 {...css(styles.projectTitle)} className={`font-weight-bold`}>
                                <a
                                  style={projectStatus === "active" ? {} : { color: "#c2c2c2" }}
                                  href={item.uri}
                                  rel="noreferrer"
                                  target="_blank"
                                  className="linkJump handlePointer"
                                >
                                  {item.repoName}
                                </a>
                              </h5>
                              <p style={{ marginBottom: "0.5rem" }}>{item.repoType}</p>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="d-flex justify-content-center align-items-center mb-2">
                  <Pagination
                    count={pageCount}
                    page={currentPage}
                    onChange={onPageChange}
                    variant="outlined"
                    shape="rounded"
                  />
                  <div className="ml-2">
                    <Select
                      labelId="pageSize"
                      id="page-size"
                      value={pageSize}
                      onChange={onPageSizeChange}
                      className="pageSizeSelect"
                    >
                      <MenuItem value={10}>10 / page</MenuItem>
                      <MenuItem value={50}>50 / page</MenuItem>
                      <MenuItem value={100}>100 / page</MenuItem>
                    </Select>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <p>There are no artifact repos.</p>
          )}
        </div>
      </>
    )
  }

  const checkIfUserIsAController = () => {
    let found = controllersData.filter(function (item) {
      return user?.nickname === item.username
    })
    return found.length === 1
  }

  const get_info = () => {
    if (_.isNil(props.location.state)) return ""
    return props.location.state.search || ""
  }

  return (
    <Layout pageTitle="Project Detail">
      <div id="project-tooltip-wrapper">
        <Breadcrumbs
          breadcrumbs={[
            { label: "Projects", path: "/projects/" + `${get_info()}` },
            { label: projectName },
          ]}
        />
        <Header contentPage={true} className="contentPage">
          <div>&nbsp;</div>
          <div className="row">
            <div className="col-lg-9">
              <h2>{projectName}</h2>
            </div>
          </div>
        </Header>
      </div>
      <Content>
        {loading ? (
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={{ size: 12 }}
            sm={{ size: 4, offset: 4 }}
          >
            <PropagateLoader
              className="align-self-center"
              size={20}
              color={"#9c3"}
              loading={true}
            />
          </Col>
        ) : (
          <></>
        )}
        {!loading && gotError ? (
          <p>{gotError}</p>
        ) : (
          <div {...css(styles.projectContent)}>
            <div style={{ marginBottom: "10px" }}>
              <ProjectButton URL={gitUrl} Label="Git" projectStatus={projectStatus} />
              <ProjectButton
                URL={artifactoryUrl}
                Label="Artifacts"
                projectStatus={projectStatus}
                handleClick={() => {
                  // window.location.hash = "artifacts"
                  window.history.pushState(
                    "",
                    "",
                    window.location.origin + window.location.pathname + "#artifacts"
                  )
                  setActiveTab("4")
                }}
              />
              <ProjectButton URL={wikiUrl} Label="Wiki" projectStatus={projectStatus} />
              <ProjectButton URL={wikiRSS} Label="RSS" projectStatus={projectStatus} />
            </div>
            <Row className="mb-2">
              <Col style={{ textAlign: "left" }}>
                <ProjectLinksView project={props} />
              </Col>
              {!loading ? (
                <Col style={{ textAlign: "right" }}>
                  {isSuperAdmin || (isOperate && isUserOrgAndProjectOrgTheSame()) ? (
                    <Button
                      color="primary"
                      className="mr-2"
                      onClick={() => {
                        navigate(
                          `/secure/projects/${props.parentOrganization}/${props.projectSlug}/edit/`,
                          {
                            state: { from: window.location.pathname },
                          }
                        )
                      }}
                    >
                      Edit
                    </Button>
                  ) : null}
                  {isSuperAdmin ||
                  ((isOperate || isSystemAdmin || isProjectAdmin || checkIfUserIsAController()) &&
                    isUserOrgAndProjectOrgTheSame()) ? (
                    <Button
                      color="primary"
                      className="mr-2"
                      onClick={() => {
                        navigate(
                          `/organization/${props.parentOrganization.toLowerCase()}/project/${
                            props.projectSlug
                          }/metrics`,
                          {
                            state: { from: window.location.pathname },
                          }
                        )
                      }}
                    >
                      View Project Metrics
                    </Button>
                  ) : null}
                  {isSuperAdmin || (isOperate && isUserOrgAndProjectOrgTheSame()) ? (
                    <Button
                      color="primary"
                      onClick={() => {
                        navigate(
                          `/secure/projects/${props.parentOrganization}/${props.projectSlug}/access-control/`,
                          {
                            state: { from: window.location.pathname },
                          }
                        )
                      }}
                    >
                      Access Control
                    </Button>
                  ) : null}

                  {gitUrl &&
                  (isSuperAdmin ||
                    ((isOperate || isSystemAdmin || isProjectAdmin || checkIfUserIsAController()) &&
                      isUserOrgAndProjectOrgTheSame())) &&
                  projectGetResponse.ci_status.allowed_by_org !== undefined &&
                  projectGetResponse.ci_status.allowed_by_org ? (
                    <>
                      &nbsp;
                      <Button
                        color="primary"
                        className="mr-2"
                        // onClick={() => {
                        //   save_ci_status(!projectGetResponse.ci_enabled)
                        // }}
                        onClick={handleCiEnableOpen}
                      >
                        {projectGetResponse.ci_status.enabled !== undefined &&
                          projectGetResponse.ci_status.enabled && <>Disable CI</>}
                        {projectGetResponse.ci_status.enabled !== undefined &&
                          !projectGetResponse.ci_status.enabled && <>Enable CI</>}
                      </Button>
                      <Popover
                        open={!!ciEnableEl}
                        anchorEl={ciEnableEl}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        onClose={handleCiEnableClose}
                      >
                        <div>
                          <Typography className={classes.typography}>{`Do you really want to ${
                            !projectGetResponse.ci_status.enabled ? "enable" : "disable"
                          } the CI for this project?`}</Typography>
                          <div {...css(styles.popoverBtn)}>
                            {" "}
                            <Button className="mr-2" onClick={handleCiEnableClose}>
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              className="mr-2"
                              color={"primary"}
                              onClick={() => {
                                save_ci_status(!projectGetResponse.ci_status.enabled)
                              }}
                            >
                              YES
                            </Button>
                          </div>
                        </div>
                      </Popover>
                    </>
                  ) : null}
                </Col>
              ) : null}
              {/* {isOperate && !isSuperAdmin && !loading ? (
                <Col style={{ textAlign: "right" }}>
                  <Button
                    color="primary"
                    className="mr-2"
                    onClick={() => {
                      navigate(
                        `/secure/projects/${props.parentOrganization}/${props.projectSlug}/edit/`,
                        {
                          state: { from: window.location.pathname },
                        }
                      )
                    }}
                  >
                    Edit
                  </Button>

                  <Button
                    color="primary"
                    onClick={() => {
                      navigate(
                        `/secure/projects/${props.parentOrganization}/${props.projectSlug}/access-control/`,
                        {
                          state: { from: window.location.pathname },
                        }
                      )
                    }}
                  >
                    Access Control
                  </Button>
                </Col>
              ) : null} */}
            </Row>

            {tabsName.length > 0 ? (
              <>
                <div style={{ width: "100%" }}>
                  <Nav tabs>{navLink(tabsName)}</Nav>
                </div>
                <TabContent {...css(styles.publicProjectContainer)} activeTab={activeTab}>
                  <TabPane tabId="0">
                    <h4 {...css(styles.projectTitle)} className={`font-weight-bold`}>
                      <span>Descriptions</span>
                    </h4>
                    <Row>
                      <Col sm="12">
                        <div {...css(styles.projectList)}>
                          <div
                            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                            // dangerouslySetInnerHTML={{ __html: projectDescription }}
                          >
                            {projectDescription}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {controllersData.length > 0 && (
                      <>
                        <h4 {...css(styles.projectTitle)} className={`font-weight-bold`}>
                          <span>Controllers</span>
                        </h4>
                        <Row>
                          <Col sm="12">
                            <div {...css(styles.projectList)}>{getTabContent("controller")}</div>
                          </Col>
                        </Row>
                      </>
                    )}

                    {licensesData.length > 0 && (
                      <>
                        <h4 {...css(styles.projectTitle)} className={`font-weight-bold`}>
                          <span>Licenses</span>
                        </h4>
                        <Row>
                          <Col sm="12">
                            <div {...css(styles.projectList)}>{getTabContent("license")}</div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </TabPane>
                  {/* <TabPane tabId="1">
                    <Row>
                      <Col sm="12">
                        <div {...css(styles.projectList)}>{getTabContent("controller")}</div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <Row>
                      <Col sm="12">
                        <div {...css(styles.projectList)}>{getTabContent("license")}</div>
                      </Col>
                    </Row>
                  </TabPane> */}
                  <TabPane tabId="3" {...css(styles.marginTop20)}>
                    <div {...css(styles.projectList)}>{getTabContent("mirror")}</div>
                  </TabPane>
                  <TabPane tabId="4" {...css(styles.marginTop20)}>
                    <div {...css(styles.projectList)}>{getTabContent("artifacts")}</div>
                  </TabPane>
                  {(isProjectAdmin ||
                    isSuperAdmin ||
                    isSystemAdmin ||
                    check_if_user_is_single_project_admin()) &&
                    activeTab === "5" && (
                      <TabPane tabId="5" {...css(styles.marginTop20)}>
                        {projectGetResponse?.ci_status?.enabled && activeTab === "5" && (
                          <>
                            {/* <TabPane tabId="9" {...css(styles.marginTop20)}> */}
                            <CIStatus
                              project={projectGetResponse}
                              urlparams={getAdditionalUrlParams()}
                            />
                            {/* </TabPane> */}
                          </>
                        )}
                        <div {...css(styles.projectList)}>
                          <CIUsageIndex
                            projectSlug={projectGetResponse.projectSlug}
                            parentOrg={projectGetResponse.parentOrganization}
                            orgIndex={index}
                          />
                        </div>
                      </TabPane>
                    )}
                  {projectGetResponse?.ci_status?.enabled && activeTab === "9" && (
                    <>
                      <TabPane tabId="9" {...css(styles.marginTop20)}>
                        <CIStatus
                          project={projectGetResponse}
                          urlparams={getAdditionalUrlParams()}
                        />
                      </TabPane>
                    </>
                  )}
                </TabContent>
              </>
            ) : null}
          </div>
        )}
      </Content>
    </Layout>
  )
}

const styles = {
  projectContent: {
    marginTop: "-10px",
  },
  projectServer: {
    width: "100%",
    display: "flex",
  },
  projectList: {
    marginTop: "20px",
  },
  navLink: {
    cursor: "pointer",
  },
  liceneseName: {
    width: "500px",
  },
  modal: {
    maxHeight: "calc(100vh - 200px)",
    overflowY: "auto",
  },
  publicProjectContainer: {
    position: "relative",
    border: "0.75px solid #ebebeb",
    borderRadius: "12px",
    padding: "15px 1rem",
  },
  projectTitle: {
    color: "#9c3",
    marginBottom: 0,
  },
}
